import React, { Fragment, Component } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

const WrapperContainer = styled.div`
  margin: 0 20px;
`;

class Wrapper extends Component {
  constructor(props) {
    super(props);
  }

  static defaultProps = {

  }

  state = {

  }

  render() {

    return (
      <WrapperContainer>
        { this.props.children }
      </WrapperContainer>
    )
  }

}

Wrapper.propTypes = {

}

export { Wrapper }


// WEBPACK FOOTER //
// ./src/components/Wrapper/Wrapper.js